import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";
import { IUserForgotOutput } from "@types";
import auth from "@api/auth";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import Button from "@elements/button";
import TextInput from "@elements/fields/textInput";
import { useTranslations } from "next-intl";
import { getNotifyConfig } from "@utils/helpers";

interface ForgotPasswordFormProps {
    onSwitchView: (view: string) => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onSwitchView }) => {
    const router = useRouter();
    const t = useTranslations();

    const forgotValues: IUserForgotOutput = { email: "" };

    const ForgotSchema = Yup.object().shape({
        email: Yup.string().email(t("client_errors_emailnotvalid")).required(t("client_errors_fieldisrequiered")),
    });

    const handelForgot = async (value: IUserForgotOutput, actions: FormikHelpers<IUserForgotOutput>) => {
        try {
            const res = await auth.forgotPass(value).fetch();
            if (res.data.success) {
                toast.success(res.meta.msg, getNotifyConfig());
                onSwitchView("login");
            }
        } catch (error) {
            console.log(error);
        }
        actions.setSubmitting(false);
    };

    return (
        <div className="w-full">
            <p className=" my-5 text-sm font-bold text-[#999] px-10">
                {t("client_bottomsheets_forgotpass_message")}
            </p>
            <div className="w-full mt-14">
                <Formik
                    initialValues={forgotValues}
                    validationSchema={ForgotSchema}
                    onSubmit={(values, actions) => {
                        handelForgot(values, actions);
                    }}
                >
                    {({ isSubmitting, isValid, dirty, handleBlur, handleChange, values, touched, errors }) => (
                        <Form className="flex flex-col max-w-[320px] w-full m-auto form">
                            <div className="w-full mb-6">
                                <TextInput
                                    error={errors.email && touched.email ? errors.email : ""}
                                    value={values.email}
                                    name="email"
                                    label={t("client_general_email")}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            <Button
                                className="h-12 shadow-md  font-extrabold text-base mb-2 rounded-full"
                                size="slim"
                                type="submit"
                                theme="blue"
                                isDisabled={isSubmitting || !isValid || !dirty}
                                loading={isSubmitting}
                            >
                                {t("client_buttons_sendlink")}
                            </Button>
                            <div className="w-full mb-2 " dir={router.locale?.includes("ar-") ? "rtl" : "ltr"}>
                                <span className="text-[#999] font-normal text-sm">
                                    {t("w-alreadyHaveAnAccount")}
                                </span>
                                <button
                                    onClick={() => onSwitchView("login")}
                                    className="text-[#008AF6] font-normal text-xs px-1"
                                >
                                    {t("client_buttons_login")}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default ForgotPasswordForm;
